import { render, staticRenderFns } from "./DialogInventory.vue?vue&type=template&id=e52db144"
import script from "./DialogInventory.vue?vue&type=script&lang=js"
export * from "./DialogInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports